import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    Row,
    Col,
    Card,
    Table,
    Button,
    notification,
    Modal,
    Tag,
} from "antd";
import { skeletonData } from '../../components/skeletons/Faq';
import apiClient from "../../services/api";
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined, EyeOutlined } from "@ant-design/icons";
import { handleApiError, handleApiSuccess, handleApiInfo } from "../../utils/errorHandler";
import { createSafeHTML } from "../../utils/sanitize";
import logger from "../../utils/logger";
const { confirm } = Modal;

// table code start
const columns = [
    {
        title: "Question",
        dataIndex: "name",
        key: "name"
    },
    {
        title: "Answer",
        dataIndex: "description",
        key: "description",
    },
    {
        title: "Status",
        key: "status",
        dataIndex: "status",
    },
    {
        title: "Action",
        key: "action",
        dataIndex: "action",
    }
];

function FaqList() {
    const [faqList, setFaqList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [answer, setAnswer] = useState('');
    const [modalVisible, setModalVisible] = useState(false);

    useEffect(() => {
        getFaqList()
    }, [])

    async function getFaqList() {
        try {
            setLoading(true);
            const response = await apiClient.get('/api/faq/listAll');
            if (response.status === 200) {
                setFaqList(response.data.result);
            } else {
                handleApiInfo(response.data.message);
            }
        } catch (error) {
            handleApiError(error);
            logger.error("API error:", error);
        } finally {
            setLoading(false);
        }
    };

    async function handleDelete(id) {
        try {
            const response = await apiClient.delete(`/api/faq/${id}`);
            if (response.status === 200) {
                getFaqList();
                handleApiSuccess('Faq deleted successfully!');
            } else {
                handleApiInfo(response.data.message);
            }
        } catch (error) {
            handleApiError(error);
            logger.error("API error:", error);
        }
    };

    const showDeleteConfirm = (id) => {
        confirm({
            title: 'Are you sure you want to delete this item?',
            icon: <ExclamationCircleOutlined />,
            content: 'This action cannot be undone.',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                handleDelete(id);
            },
        });
    };

    const showModal = (answer) => {
        setAnswer(answer);
        setModalVisible(true);
    };

    const handleOk = () => {
        setModalVisible(false);
    };

    const handleCancel = () => {
        setModalVisible(false);
    };

    return (
        <>
            <div className="tabled">
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="FAQ"
                            extra={
                                <>
                                    <Link className="custom-btn" to="/faq/add">Add</Link>
                                </>
                            }
                        >
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={loading ? skeletonData : faqList.map((user, index) => ({
                                        key: index.toString(),
                                        name: (
                                            <div className="author-info">
                                                <p>{user.question}</p>
                                            </div>
                                        ),
                                        description: (
                                            <Button type="primary" onClick={() => showModal(user.answer, 'Description')}>
                                                <EyeOutlined />
                                            </Button>
                                        ),
                                        status: (
                                            user.enabled ? <Tag color="success">Active</Tag> : <Tag color="red">Inactive</Tag>
                                        ),
                                        action: (
                                            <div className="button-container">
                                                <Link to={`/faq/update/${user._id}`} className="update-btn">
                                                    <EditOutlined />
                                                </Link>
                                                <button onClick={() => showDeleteConfirm(user._id)} className="delete-btn">
                                                    <DeleteOutlined />
                                                </button>
                                            </div>
                                        )
                                    }))}
                                    pagination={false}
                                    className="ant-border-space"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
            <Modal
                title={`Answer`}
                visible={modalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <div className="author-info">
                    <div dangerouslySetInnerHTML={{ __html: createSafeHTML(answer) }} />
                </div>
            </Modal>
        </>
    );
}

export default FaqList;
